module.exports = __webpack_public_path__ + "cement/img/1(3).87fac912.png";